import { hotList } from "@/mocks/guagua";

const trendIcon: Record<string, { cls: string; icon: string }> = {
  up: { cls: "text-primary-500", icon: "ri-arrow-up-line" },
  down: { cls: "text-secondary-500", icon: "ri-arrow-down-line" },
  flat: { cls: "text-foreground-400", icon: "ri-subtract-line" },
};

function rankColor(rank: number) {
  if (rank <= 3) return "text-primary-600";
  if (rank <= 5) return "text-foreground-800";
  return "text-foreground-400";
}

export default function Hero() {
  const top = hotList.slice(0, 5);
  const rest = hotList.slice(5, 10);

  return (
    <section id="guanwang" className="scroll-mt-[132px] py-10 md:py-14">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-8 md:gap-10 items-center">
          {/* left intro */}
          <div className="lg:col-span-4">
            <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
              <i className="ri-rainbow-line"></i> 吃瓜群众速报
            </p>
            <h1 className="mt-4 font-heading font-black text-3xl md:text-5xl text-foreground-950 leading-tight">
              今日瓜王<span className="text-primary-600">在这里</span>
            </h1>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              每天为你摘最新鲜的瓜，今日瓜田汇总、热搜背后故事、营销号没敢说的，全网热瓜一网打尽。理性吃瓜，拒绝被带节奏。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a href="#guatian" className="whitespace-nowrap px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors inline-flex items-center gap-2">
                去看看今天的瓜 <i className="ri-arrow-right-line"></i>
              </a>
              <a href="#discuss" className="whitespace-nowrap px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium hover:border-foreground-500 hover:bg-background-100 transition-colors inline-flex items-center gap-2">
                进瓜友讨论区
              </a>
            </div>
            <div className="mt-6 flex items-center gap-6 text-foreground-700">
              <div>
                <p className="font-label text-2xl text-primary-600">128</p>
                <p className="text-xs text-foreground-500">今日新增瓜</p>
              </div>
              <div>
                <p className="font-label text-2xl text-primary-600">9.6万</p>
                <p className="text-xs text-foreground-500">瓜友在线</p>
              </div>
              <div>
                <p className="font-label text-2xl text-primary-600">32</p>
                <p className="text-xs text-foreground-500">话题爆了</p>
              </div>
            </div>
          </div>

          {/* featured card */}
          <div className="lg:col-span-8">
            <article className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200">
              <div className="grid md:grid-cols-2">
                <div className="relative h-60 md:h-auto overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20award%20ceremony%20at%20night%20with%20warm%20golden%20stage%20lights%20and%20coral%20accent%20lighting%2C%20fashionable%20crowd%20silhouettes%2C%20elegant%20premium%20entertainment%20editorial%20photo%2C%20rich%20atmosphere&width=1000&height=900&seq=gua-2026-hero&orientation=squarish"
                    alt="年度盛典红毯造型盘点 今晚热搜主角"
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-background-50/90 text-primary-700 text-xs font-semibold flex items-center gap-1">
                    <i className="ri-vip-crown-2-line"></i> 今日瓜王
                  </span>
                </div>
                <div className="p-6 md:p-8 flex flex-col justify-center">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="px-2 py-0.5 rounded bg-primary-100 text-primary-700 font-medium">综艺</span>
                    <span>{hotList[0].heat} 阅读</span>
                  </div>
                  <h3 className="mt-3 font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug">
                    年度盛典红毯造型盘点：谁赢了镜头，谁被造型师"坑"了
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    红毯向来是艺人审美与造型团队的正面battle场。这一晚既有封神的高定，也有翻车的搭配。我们把高清生图一一拆解，看看谁是真正的红毯赢家。
                  </p>
                  <div className="mt-5 flex items-center gap-3 text-xs text-foreground-500">
                    <span>编辑 · 一颗吃瓜的橘子</span>
                    <span>·</span>
                    <span>2小时前</span>
                  </div>
                  <a href="#guatian" className="mt-5 inline-flex items-center gap-2 text-primary-600 text-sm font-semibold">
                    进入瓜田细看 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>

        {/* ranking list */}
        <div className="mt-10 grid lg:grid-cols-2 gap-6 md:gap-8">
          <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-fire-fill text-primary-500"></i> 热搜 TOP 5
              </h4>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-refresh-line text-primary-500"></i> 10分钟更新
              </span>
            </div>
            <ul className="space-y-1">
              {top.map((h) => {
                const t = trendIcon[h.trend];
                return (
                  <li key={h.rank} className="flex items-center gap-3 px-3 py-2.5 hover:bg-background-50 rounded-xl transition-colors">
                    <span className={`w-7 font-label text-xl text-center shrink-0 ${rankColor(h.rank)}`}>
                      {h.rank}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-foreground-800 font-medium truncate">{h.title}</p>
                      <p className="text-xs text-foreground-500">{h.tag} · {h.heat}</p>
                    </div>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 ${h.rank <= 3 ? "bg-primary-100 text-primary-600" : "bg-background-200 text-foreground-500"} ${t.cls}`}>
                      <i className={t.icon}></i>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-pulse-line text-primary-500"></i> 实时升温榜
              </h4>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-time-line text-primary-500"></i> 每分钟更新
              </span>
            </div>
            <ul className="space-y-1">
              {rest.map((h) => {
                const t = trendIcon[h.trend];
                return (
                  <li key={h.rank} className="flex items-center gap-3 px-3 py-2.5 hover:bg-background-50 rounded-xl transition-colors">
                    <span className={`w-7 font-label text-xl text-center shrink-0 ${rankColor(h.rank)}`}>
                      {h.rank}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-foreground-800 font-medium truncate">{h.title}</p>
                      <p className="text-xs text-foreground-500">{h.tag} · {h.heat}</p>
                    </div>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 bg-background-200 text-foreground-500 ${t.cls}`}>
                      <i className={t.icon}></i>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}